import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class TemplateService {
    //new
    public selectedReport: any;
    public reportControl: any;
    public refTablesListControl: any;
    public check: boolean = false;

    //
    public selectedProcess: any;
    public wizard: any = {};
    public selectedControl: any;
    public selectedStep: any;
    public referentials: any;
    public offerProcessCode: any;
    public offerProductCode: any;
    public offerDepartmentCode: any;
    public policyProcessCode: any;
    public policyProductCode: any;
    public departmentCode: any;
    public versionNo: any;
    public claimProcessCode: any; 
    public claimProductCode: any; 

    constructor(private toastrService: ToastrService)
    {
        this.wizard.Steps = {
            "1": {
                "Code": "1",
                "Text": "Client Details",
                "Codes": [],
                "GroupCodes": [],
                "Controls": {},
                "ControlGroups": {},
                "Type": "Standard"
            }
        };
        this.selectedStep = this.wizard.Steps["1"];
    }
    /*public ClearTemplate() {
        this.reportControl;
        this.check = true;
        return;
    }*/
    public reset() {
        this.wizard = {};
        this.selectedControl = null;
        this.referentials = null;

        this.wizard.Steps = {
            "1": {
                "Code": "1",
                "Text": "Client Details",
                "Codes": [],
                "GroupCodes": [],
                "Controls": {},
                "ControlGroups": {},
                "Type": "Standard"
            }
        };

        this.selectedStep = this.wizard.Steps["1"];
    }

    //execute script
    public executeScript(referentials, wizard, control, event, variables, scripts, cover,
        offerCode, itemCode = null, searchResult = null, sectionCode = null, parentItemCode = null) {

        var wizardSteps;
        var wizardViews;

        if (wizard.Steps) {
            wizardSteps = wizard.Steps;
        }
        if (wizard.Views) {
            wizardViews = wizard.Views;
        }
        else {
            wizardSteps = wizard;
            wizardViews = "";
        }

        if (!control) control = {};

        if (event == undefined || event == null) event = 'OnChange';

        var script = null;
        if ((event === "OnChange" || event === "OnLoad" || event === "OnBlur" || event === "OnCalcComplete" || event === "OnSearchSelect")
            && control.Properties
            && control.Properties[event])
            script = control.Properties[event].Value;
        else if (event && scripts && scripts[event] && !control.Scripts)
            script = scripts[event].Value;
        else if (event && cover && cover.Scripts && !control.Scripts && !scripts[event])
            script = cover.Scripts[event].Value;

        var result = null;
        if (script) result = this.execute(script, referentials, wizard, wizardSteps,
            wizardViews, control, event, offerCode, variables, cover, itemCode, searchResult, sectionCode, parentItemCode);

        if (control.Scripts && scripts) {
            for (var scriptKey in control.Scripts) {
                if (control.Scripts[scriptKey] &&
                    scripts[scriptKey] &&
                    scripts[scriptKey].Value &&
                    ((event == 'OnChange' && scripts[scriptKey].IsChange) ||
                        (event == 'OnLoad' && scripts[scriptKey].IsLoad) ||
                        (event === 'OnBlur' && scripts[scriptKey].IsBlur)))
                    result = this.execute(scripts[scriptKey].Value, referentials, wizard, wizardSteps,
                        wizardViews, control, event, offerCode, variables, cover, itemCode, searchResult, sectionCode, parentItemCode);
            }
        }
        return result;
    }

    execute(script, referentials, wizard, wizardSteps, wizardViews, control, event, offerCode,
        variables, cover, itemCode, searchResult, sectionCode, parentItemCode)  {
        try {
            script = this.parseScript(wizardSteps, wizardViews, script, offerCode, itemCode, sectionCode, parentItemCode);

            /*Added By ZAHRAA */

            var offers = {};
            for (var stepKey in wizardSteps) {
                if (wizardSteps[stepKey].Type == "Offer") {
                    offers = wizardSteps[stepKey].Offers;
                    break;
                }
            }

            var global = {
                "getControlByName": this.getControlByName,
                "Field": control,
                "Variables": variables,
                "Global": { "Variables": variables },
                "Value": control.Value,
                "OfferCode": offerCode,
                //"Offers": offers,
                "ReferentialData": this.referentialData,
                "Referential": referentials,
                "Steps": wizardSteps,
                //"notificationService": notificationService,
                "Controls": function (userName) {
                    var control = global.getControlByName(wizardSteps, userName);

                    if (control != null) {
                        control.Property = function (propertyName) {
                            if (control.Properties && control.Properties[propertyName])
                                return control.Properties[propertyName];
                            else
                                return null;
                        }
                    }

                    return control;
                },
                "Reset": function (userName) {
                    var control = global.getControlByName(wizardSteps, userName);

                    if (control != null) {
                        if (document.getElementsByName(control.Code) &&
                            document.getElementsByName(control.Code).length > 0) {
                            var element = document.getElementsByName(control.Code)[0];
                            element.nodeValue = "";
                        }
                        control.Value = "";
                        control.DateValue = "";
                        control.reset();
                    }
                },
                "SetValue": function (userName,value) {
                    var control = global.getControlByName(wizardSteps, userName);

                    if (control != null) {
                        if (document.getElementsByName(control.Code) &&
                            document.getElementsByName(control.Code).length > 0) {
                            var element = document.getElementsByName(control.Code)[0];

                            var temp: any = element.parentElement.parentElement;

                            temp.dxDateBox({     
                                value: control.DateValue
                            });

                            element.nodeValue = value;
                        }
                        control.Value = value;
                    }
                },
                "Sections": function (sectionCode) {
                    var attrbs = {
                        "Show": function () {
                            for (var stepKey in wizardSteps) {
                                if (offerCode == null) {
                                    for (var sectionKey in wizardSteps[stepKey].Sections) {
                                        if (sectionCode == sectionKey) {
                                            wizardSteps[stepKey].Sections[sectionKey].Visible = true;
                                            break;
                                        }
                                    }
                                }
                                if (wizardSteps[stepKey].Type == "Offer") {
                                    for (var offerKey in wizardSteps[stepKey].Offers) {
                                        if (offerCode != null && offerCode != offerKey) continue;
                                        for (var sectionKey in wizardSteps[stepKey].Offers[offerKey].Sections) {
                                            if (sectionCode == sectionKey) {
                                                wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Visible = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "Hide": function () {
                            for (var stepKey in wizardSteps) {
                                if (offerCode == null) {
                                    for (var sectionKey in wizardSteps[stepKey].Sections) {
                                        if (sectionCode == sectionKey) {
                                            wizardSteps[stepKey].Sections[sectionKey].Visible = false;
                                            break;
                                        }
                                    }
                                }
                                if (wizardSteps[stepKey].Type == "Offer") {
                                    for (var offerKey in wizardSteps[stepKey].Offers) {
                                        if (offerCode != null && offerCode != offerKey) continue;
                                        for (var sectionKey in wizardSteps[stepKey].Offers[offerKey].Sections) {
                                            if (sectionCode == sectionKey) {
                                                wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Visible = false;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    };
                    return attrbs;
                },
                "Offers": function (offCode) {
                    var attrbs = {
                        "Show": function () {
                            for (var stepKey in wizardSteps) {
                                if (wizardSteps[stepKey].Type == "Offer" &&
                                    wizardSteps[stepKey].Offers[offCode]) {
                                    wizardSteps[stepKey].Offers[offCode].Visible = true;
                                    break;
                                }
                            }
                        },
                        "Hide": function () {
                            for (var stepKey in wizardSteps) {
                                if (wizardSteps[stepKey].Type == "Offer" &&
                                    wizardSteps[stepKey].Offers[offCode]) {
                                    wizardSteps[stepKey].Offers[offCode].Visible = false;
                                    break;
                                }
                            }
                        }
                    };
                    return attrbs;
                },
                "validateFormat": this.validateFormat,
                //"confirmMessage": confirmMessage,
                "Offer": function (offCode) {
                    var tmpOffer = null;
                    var stepKey = null;
                    for (stepKey in wizardSteps) {
                        if (wizardSteps[stepKey].Type == "Offer" &&
                            wizardSteps[stepKey].Offers[offCode]) {
                            tmpOffer = wizardSteps[stepKey].Offers[offCode];
                            break;
                        }
                    }

                    if (tmpOffer) {
                        tmpOffer.Display = function (value) {
                            tmpOffer.Visible = value;
                        }
                        tmpOffer.Select = function (value) {
                            tmpOffer.Selected = value;
                        }
                        tmpOffer.Section = function (secCode) {
                            var tmpSection = null;
                            for (var sectionKey in wizardSteps[stepKey].Offers[offCode].Sections) {
                                if (secCode == sectionKey) {
                                    tmpSection = wizardSteps[stepKey].Offers[offCode].Sections[sectionKey];
                                    break;
                                }
                            }
                            if (tmpSection) {
                                tmpSection.Cover = function (covCode) {
                                    var tmpCover = null;
                                    for (var coverKey in wizardSteps[stepKey].Offers[offCode].Sections[secCode].Covers) {
                                        if (covCode == coverKey) {
                                            tmpCover = wizardSteps[stepKey].Offers[offCode].Sections[secCode].Covers[coverKey];
                                            break;
                                        }
                                    }
                                    if (tmpCover != null) {
                                        tmpCover.Select = function (value, selection) {
                                            tmpCover.Selected = value; 
                                            tmpCover.Selection = selection;
                                            if (tmpCover.Scripts && tmpCover.Scripts['OnChange'] && tmpCover.Scripts['OnChange'].IsChange) {
                                                this.executeScript(referentials, wizard, tmpCover, null, variables, tmpCover.Scripts, tmpCover, offerCode)
                                            }
                                        }
                                    }

                                    return tmpCover;
                                }
                            }

                            return tmpSection;
                        }
                    };

                    return tmpOffer;
                }
            }

            
            var tmpFunc = new Function('notificationService','Field', 'Variables', 'Global', 'Value', 'OfferCode', 'Offers', 'ReferentialData',
                'Referential', 'Steps', 'Views', 'validateFormat', 'Sections', 'Controls', 'Cover', script);

            var result = tmpFunc(this.toastrService, control, variables, global, control.Value, offerCode, offers, this.referentialData,
                referentials, wizardSteps, wizardViews, this.validateFormat, global.Sections, global.Controls, cover);

            global = null;
            
        } catch (err) {

            global = null;
            return err;
        }

        /*END*/
    }

    parseScript(wizardSteps, wizardViews, script, offerCode, itemCode, sectionCode, parentItemCode = null) {

        var regexp = /Offers\[[a-z_0-9]*(,[a-z_0-9]*)?(,[a-z_0-9]*)?\].[A-Za-z0-9_]*.[a-z]*/gi;
        var controlNames = script.match(regexp);
        var tempSectionCode = null, tempItemCode = null;
        if (controlNames && controlNames.length) {
            var controlKeys = {};
            for (var i = 0; i < controlNames.length; i++)
                controlKeys[controlNames[i]] = "";
            for (var key in controlKeys) {
                if (key && key.indexOf('(') > 0) continue;
                var keys = key.split('.');
                var codes = keys[0].replace("Offers", "").replace("[", "").replace("]", "").split(',');
                tempSectionCode = null;
                tempItemCode = null;
                if (codes.length > 0) offerCode = codes[0].trim();
                if (codes.length > 1) tempSectionCode = codes[1].trim();
                if (codes.length > 2) tempItemCode = codes[2].trim();
                if (keys.length > 1 && keys[1].indexOf('[') > 0) {
                    continue;
                }
                if (!tempItemCode && itemCode)
                    tempItemCode = itemCode;
                var value = this.offerControlValueByUserName(wizardSteps, wizardViews, keys[1], keys[2], offerCode, tempItemCode, tempSectionCode);

                key = key.replace("[", "\\[").replace("]", "\\]");
                script = script.replace(new RegExp(key, 'g'), value);
            }
        }

        regexp = /Control.[A-Za-z0-9_]*.[a-z]*/gi;
        controlNames = script.match(regexp);
        if (controlNames && controlNames.length) {
            var controlKeys = {};
            for (var i = 0; i < controlNames.length; i++)
                controlKeys[controlNames[i]] = "";
            for (var key in controlKeys) {
                if (key && key.indexOf('(') > 0) continue;
                if (key && key.indexOf('[') > 0) continue;
                var keys = key.split('.');
                var value = this.controlValueByUserName(wizardSteps, wizardViews, keys[1], keys[2], offerCode, itemCode, sectionCode, parentItemCode);
                script = script.replace(new RegExp(key, 'g'), value);
            }
        }

        script = script.replace(/confirm\(/g, "confirmMessage(");
        //script = script.replace(/Referential.New\(/g, "ReferentialData('New',Referential,");
        script = script.replace(/notificationService.displaySuccess/g, "notificationService.success");
        script = script.replace(/notificationService.displayError/g, "notificationService.error");
        script = script.replace(/notificationService.displayWarning/g, "notificationService.warning");
        script = script.replace(/notificationService.displayInfo/g, "notificationService.info");
        script = script.replace(/alert\(/g, "notificationService.success(");
        return script;
    }

    offerControlValueByUserName(wizardSteps, wizardViews, userName, propertyName, offerCode, itemCode, sectionCode = null) {

        if (userName) userName = userName.trim();
        if (propertyName) propertyName = propertyName.trim();

        for (var stepKey in wizardSteps) {
            if (wizardSteps[stepKey].Type != 'Offer') continue;

            //only offer level properties
            if (!itemCode && !sectionCode && !propertyName && userName &&
                (userName == "Visible" || userName == "Selected")) {
                return "Offers[" + offerCode + "]." + userName;
            }

            for (var offerKey in wizardSteps[stepKey].Offers) {
                for (var controlKey in wizardSteps[stepKey].Offers[offerKey].Controls) {
                    var control = wizardSteps[stepKey].Offers[offerKey].Controls[controlKey];
                    if (control.Properties &&
                        control.Properties["UserName"] &&
                        control.Properties["UserName"].Value == userName) {
                        if (propertyName == "Value" ||
                            propertyName == "ValueText" ||
                            propertyName == "Selected" ||
                            propertyName == "Referential" ||
                            propertyName == "DateValue" ||
                            propertyName == "setDate" ||
                            propertyName == "setMinDate" ||
                            propertyName == "setMaxDate") {
                            return "Offers[" + offerCode + "].Controls['" + controlKey + "']." + propertyName;
                        }
                        else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                            return "Offers[" + offerCode + "].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                        else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                            return "Offers[" + offerCode + "].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                    }
                }

                if (sectionCode) {
                    for (var sectionKey in wizardSteps[stepKey].Offers[offerKey].Sections) {
                        if (sectionCode && sectionCode != sectionKey) continue;
                        var controls = wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Controls;
                        for (var controlKey in controls) {
                            if (controls[controlKey].Properties &&
                                controls[controlKey].Properties["UserName"] &&
                                controls[controlKey].Properties["UserName"].Value == userName) {
                                if (propertyName == "Value" ||
                                    propertyName == "ValueText" ||
                                    propertyName == "Selected" ||
                                    propertyName == "Referential" ||
                                    propertyName == "DateValue" ||
                                    propertyName == "setDate" ||
                                    propertyName == "setMinDate" ||
                                    propertyName == "setMaxDate") {
                                    return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Controls['" + controlKey + "']." + propertyName;
                                }
                                else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                                    return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                                    return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                            }
                        }

                        for (var groupKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups) {
                            var controls = wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups[groupKey].Controls;
                            for (var controlKey in controls) {
                                if (controls[controlKey].Properties &&
                                    controls[controlKey].Properties["UserName"] &&
                                    controls[controlKey].Properties["UserName"].Value == userName) {
                                    if (propertyName == "Value" ||
                                        propertyName == "ValueText" ||
                                        propertyName == "Selected" ||
                                        propertyName == "Referential" ||
                                        propertyName == "DateValue" ||
                                        propertyName == "setDate" ||
                                        propertyName == "setMinDate" ||
                                        propertyName == "setMaxDate") {
                                        if (wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].IsMultiline && itemCode)
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Controls['" + controlKey + "']." + propertyName;
                                        else
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                    }
                                    else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                                        return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                    else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                                        return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                }
                            }
                        }
                        for (var coverKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers) {
                            var controls = wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls;
                            for (var controlKey in controls) {
                                if (controls[controlKey].Properties &&
                                    controls[controlKey].Properties["UserName"] &&
                                    controls[controlKey].Properties["UserName"].Value == userName) {
                                    if (propertyName == "Value" ||
                                        propertyName == "ValueText" ||
                                        propertyName == "Selected" ||
                                        propertyName == "Referential" ||
                                        propertyName == "DateValue" ||
                                        propertyName == "setDate" ||
                                        propertyName == "setMinDate" ||
                                        propertyName == "setMaxDate") {
                                        if (itemCode)
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "']." + propertyName;
                                        else
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "']." + propertyName;
                                    }
                                    else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required") {
                                        if (itemCode)
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                        else
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                    } else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired") {
                                        if (itemCode)
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                        else
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                    }
                                }

                            }
                            for (var groupKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups) {
                                var controls = wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups[groupKey].Controls;
                                for (var controlKey in controls) {
                                    if (controls[controlKey].Properties &&
                                        controls[controlKey].Properties["UserName"] &&
                                        controls[controlKey].Properties["UserName"].Value == userName) {
                                        if (propertyName == "Value" ||
                                            propertyName == "ValueText" ||
                                            propertyName == "Selected" ||
                                            propertyName == "Referential" ||
                                            propertyName == "DateValue" ||
                                            propertyName == "setDate" ||
                                            propertyName == "setMinDate" ||
                                            propertyName == "setMaxDate") {
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                        }
                                        else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                        else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                                            return "Offers[" + offerCode + "].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    //Find control path by user name
    controlValueByUserName(wizardSteps, wizardViews, userName, propertyName, offerCode, itemCode, sectionCode, parentItemCode) {
        var control = null;

        for (var stepKey in wizardSteps) {
            var controls = wizardSteps[stepKey].Controls;
            for (var controlKey in controls) {
                if (controls[controlKey].Properties &&
                    controls[controlKey].Properties["UserName"] &&
                    controls[controlKey].Properties["UserName"].Value == userName) {
                    if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue" || propertyName == "setDate" || propertyName == "setMinDate" || propertyName == "setMaxDate" || propertyName == "hasError" || propertyName == "clientError") {
                        this.attachDateProperty(controls[controlKey], propertyName);
                        return "Steps['" + stepKey + "'].Controls['" + controlKey + "']." + propertyName;
                    }
                    else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                        return "Steps['" + stepKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                    else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                        return "Steps['" + stepKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                }
            }

            for (var groupKey in wizardSteps[stepKey].ControlGroups) {
                var controls = wizardSteps[stepKey].ControlGroups[groupKey].Controls;
                for (var controlKey in controls) {
                    if (controls[controlKey].Properties &&
                        controls[controlKey].Properties["UserName"] &&
                        controls[controlKey].Properties["UserName"].Value == userName) {
                        if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue" || propertyName == "setDate" || propertyName == "setMinDate" || propertyName == "setMaxDate" || propertyName == "hasError" || propertyName == "clientError") {
                            this.attachDateProperty(controls[controlKey], propertyName);
                            return "Steps['" + stepKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                        }
                        else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                            return "Steps['" + stepKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                        else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                            return "Steps['" + stepKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                    }
                }
            }

            //gis claim
            for (var transKey in wizardSteps[stepKey].ClaimTransacReferences) {
                for (var groupKey in wizardSteps[stepKey].ClaimTransacReferences[transKey].ControlGroups) {
                    var controls = wizardSteps[stepKey].ClaimTransacReferences[transKey].ControlGroups[groupKey].Controls;
                    for (controlKey in controls) {
                        if (controls[controlKey].Properties &&
                            controls[controlKey].Properties["UserName"] &&
                            controls[controlKey].Properties["UserName"].Value == userName) {
                            if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue" || propertyName == "setDate" || propertyName == "setMinDate" || propertyName == "setMaxDate" || propertyName == "hasError" || propertyName == "clientError") {
                                this.attachDateProperty(controls[controlKey], propertyName);
                                return "Steps['" + stepKey + "'].ClaimTransacReferences['" + transKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                            }
                            else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required") {
                                return "Steps['" + stepKey + "'].ClaimTransacReferences['" + transKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                            } else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired") {
                                return "Steps['" + stepKey + "'].ClaimTransacReferences['" + transKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                            }
                        }
                    }
                }
            }

            //lis claim
            for (var sectionKey in wizardSteps[stepKey].Sections) {
                for (var transKey in wizardSteps[stepKey].Sections[sectionKey].ClaimTransacReferences) {
                    for (var groupKey in wizardSteps[stepKey].Sections[sectionKey].ClaimTransacReferences[transKey].ControlGroups) {
                        var controls = wizardSteps[stepKey].Sections[sectionKey].ClaimTransacReferences[transKey].ControlGroups[groupKey].Controls;
                        for (controlKey in controls) {
                            if (controls[controlKey].Properties &&
                                controls[controlKey].Properties["UserName"] &&
                                controls[controlKey].Properties["UserName"].Value == userName) {
                                if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue" || propertyName == "setDate" || propertyName == "setMinDate" || propertyName == "setMaxDate" || propertyName == "hasError" || propertyName == "clientError") {
                                    this.attachDateProperty(controls[controlKey], propertyName);
                                    return "Steps['" + stepKey + "'].Sections[sectionKey].ClaimTransacReferences['" + transKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                }
                                else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required") {
                                    return "Steps['" + stepKey + "'].Sections[sectionKey].ClaimTransacReferences['" + transKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                } else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired") {
                                    return "Steps['" + stepKey + "'].Sections[sectionKey].ClaimTransacReferences['" + transKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                }
                            }
                        }
                    }
                }
            }

            for (var sectionKey in wizardSteps[stepKey].Sections) {
                var parentSectionCode = null;
                if (sectionCode && wizardSteps[stepKey].Sections[sectionCode].ParentSectionCode)
                    parentSectionCode = wizardSteps[stepKey].Sections[sectionCode].ParentSectionCode;

                var controls = wizardSteps[stepKey].Sections[sectionKey].Controls;
                for (var controlKey in controls) {
                    if (controls[controlKey].Properties &&
                        controls[controlKey].Properties["UserName"] &&
                        controls[controlKey].Properties["UserName"].Value == userName) {
                        if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue" || propertyName == "setDate" || propertyName == "setMinDate" || propertyName == "setMaxDate" || propertyName == "hasError" || propertyName == "clientError") {
                            this.attachDateProperty(controls[controlKey], propertyName);
                            return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Controls['" + controlKey + "']." + propertyName;
                        }
                        else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                            return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                        else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                            return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                    }
                }

                for (var groupKey in wizardSteps[stepKey].Sections[sectionKey].ControlGroups) {
                    var controls = wizardSteps[stepKey].Sections[sectionKey].ControlGroups[groupKey].Controls;
                    for (var controlKey in controls) {
                        if (controls[controlKey].Properties &&
                            controls[controlKey].Properties["UserName"] &&
                            controls[controlKey].Properties["UserName"].Value == userName) {
                            if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue" || propertyName == "setDate" || propertyName == "setMinDate" || propertyName == "setMaxDate" || propertyName == "hasError" || propertyName == "clientError") {
                                this.attachDateProperty(controls[controlKey], propertyName);
                                if (wizardSteps[stepKey].Sections[sectionKey].IsMultiline) {
                                    if (parentSectionCode && sectionKey == parentSectionCode && parentItemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + parentSectionCode + "'].Items['" + parentItemCode + "'].Controls['" + controlKey + "']." + propertyName;
                                    } else if (itemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Controls['" + controlKey + "']." + propertyName;
                                    } else {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                    }
                                } else
                                    return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                            }
                            else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required") {
                                if (wizardSteps[stepKey].Sections[sectionKey].IsMultiline) {
                                    if (parentSectionCode && sectionKey == parentSectionCode && parentItemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + parentSectionCode + "'].Items['" + parentItemCode + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                    } else if (itemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                    } else {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                    }
                                } else
                                    return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                            } else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired") {
                                if (wizardSteps[stepKey].Sections[sectionKey].IsMultiline) {
                                    if (parentSectionCode && sectionKey == parentSectionCode && parentItemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + parentSectionCode + "'].Items['" + parentItemCode + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                    } else if (itemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                    } else {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                    }
                                } else
                                    return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                            }
                        }
                    }
                }

                for (var coverKey in wizardSteps[stepKey].Sections[sectionKey].Covers) {
                    for (var groupKey in wizardSteps[stepKey].Sections[sectionKey].Covers[coverKey].ControlGroups) {
                        var controls = wizardSteps[stepKey].Sections[sectionKey].Covers[coverKey].ControlGroups[groupKey].Controls;
                        for (var controlKey in controls) {
                            if (controls[controlKey].Properties &&
                                controls[controlKey].Properties["UserName"] &&
                                controls[controlKey].Properties["UserName"].Value == userName) {
                                if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue" || propertyName == "setDate" || propertyName == "setMinDate" || propertyName == "setMaxDate" || propertyName == "hasError" || propertyName == "clientError") {
                                    this.attachDateProperty(controls[controlKey], propertyName);
                                    if (wizardSteps[stepKey].Sections[sectionKey].IsMultiline && itemCode) {
                                        if (parentSectionCode && sectionKey == parentSectionCode) {
                                            var parentItemCode = wizardSteps[stepKey].Sections[sectionCode].Items[itemCode].ParentItemCode;
                                            return "Steps['" + stepKey + "'].Sections['" + parentSectionCode + "'].Items['" + parentItemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                        } else {
                                            if (wizardSteps[stepKey].Sections[sectionKey].Items[itemCode].Covers[coverKey].ControlGroups[groupKey])
                                                return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                            else
                                                return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "']." + propertyName;
                                        }
                                    } else if (itemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                    } else
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                                }
                                else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required") {
                                    if (wizardSteps[stepKey].Sections[sectionKey].IsMultiline && itemCode) {
                                        if (parentSectionCode && sectionKey == parentSectionCode) {
                                            var parentItemCode = wizardSteps[stepKey].Sections[sectionCode].Items[itemCode].ParentItemCode;
                                            return "Steps['" + stepKey + "'].Sections['" + parentSectionCode + "'].Items['" + parentItemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                        } else {
                                            if (wizardSteps[stepKey].Sections[sectionKey].Items[itemCode].Covers[coverKey].ControlGroups[groupKey])
                                                return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                            else
                                                return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                        }
                                    } else if (itemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                    } else
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                                } else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired") {
                                    if (wizardSteps[stepKey].Sections[sectionKey].IsMultiline && itemCode) {
                                        if (parentSectionCode && sectionKey == parentSectionCode) {
                                            var parentItemCode = wizardSteps[stepKey].Sections[sectionCode].Items[itemCode].ParentItemCode;
                                            return "Steps['" + stepKey + "'].Sections['" + parentSectionCode + "'].Items['" + parentItemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                        } else {
                                            if (wizardSteps[stepKey].Sections[sectionKey].Items[itemCode].Covers[coverKey].ControlGroups[groupKey])
                                                return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                            else
                                                return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                        }
                                    } else if (itemCode) {
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Items['" + itemCode + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                    } else
                                        return "Steps['" + stepKey + "'].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                                }
                            }
                        }
                    }
                }
            }

            if (wizardSteps[stepKey].Type != "Offer") continue;

            for (var offerKey in wizardSteps[stepKey].Offers) {
                if (offerCode && offerKey != offerCode) continue;
                var controls = wizardSteps[stepKey].Offers[offerKey].Controls;
                for (controlKey in controls) {
                    if (controls[controlKey].Properties &&
                        controls[controlKey].Properties["UserName"] &&
                        controls[controlKey].Properties["UserName"].Value == userName) {
                        if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential")
                            return "Offers['" + offerKey + "'].Controls['" + controlKey + "']." + propertyName;
                        else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                            return "Offers['" + offerKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                        else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                            return "Offers['" + offerKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                    }
                }

                if (control != null) break;
                for (var sectionKey in wizardSteps[stepKey].Offers[offerKey].Sections) {
                    var controls = wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Controls;
                    for (controlKey in controls) {
                        if (controls[controlKey].Properties &&
                            controls[controlKey].Properties["UserName"] &&
                            controls[controlKey].Properties["UserName"].Value == userName) {
                            if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential")
                                return "Offers['" + offerKey + "'].Sections['" + sectionKey + "'].Controls['" + controlKey + "']." + propertyName;
                            else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly")
                                return "Offers['" + offerKey + "'].Sections['" + sectionKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                        }
                    }
                    if (control != null) break;
                    for (var coverKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers) {
                        var controls = wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls;
                        for (var controlKey in controls) {
                            if (controls[controlKey].Properties &&
                                controls[controlKey].Properties["UserName"] &&
                                controls[controlKey].Properties["UserName"].Value == userName) {
                                if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential")
                                    return "Offers['" + offerKey + "'].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "']." + propertyName;
                                else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly")
                                    return "Offers['" + offerKey + "'].Sections['" + sectionKey + "'].Covers['" + coverKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                            }
                        }
                    }
                }
            }
        }

        for (var viewKey in wizardViews) {
            var controls = wizardViews[viewKey].Controls;
            for (var controlKey in controls) {
                if (controls[controlKey].Properties &&
                    controls[controlKey].Properties["UserName"] &&
                    controls[controlKey].Properties["UserName"].Value == userName) {
                    if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue")
                        return "Views['" + viewKey + "'].Controls['" + controlKey + "']." + propertyName;
                    else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                        return "Views['" + viewKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                    else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                        return "Views['" + viewKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                }
            }

            for (var groupKey in wizardViews[viewKey].ControlGroups) {
                var controls = wizardViews[viewKey].ControlGroups[groupKey].Controls;
                for (var controlKey in controls) {
                    if (controls[controlKey].Properties &&
                        controls[controlKey].Properties["UserName"] &&
                        controls[controlKey].Properties["UserName"].Value == userName) {
                        if (propertyName == "Value" || propertyName == "ValueText" || propertyName == "Referential" || propertyName == "DateValue")
                            return "Views['" + viewKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "']." + propertyName;
                        else if (propertyName == "Visible" || propertyName == "ReadOnly" || propertyName == "Required")
                            return "Views['" + viewKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['Offer" + propertyName + "'].Value";
                        else if (propertyName == "OfferVisible" || propertyName == "PolicyVisible" || propertyName == "OfferReadOnly" || propertyName == "PolicyReadOnly" || propertyName == "OfferRequired" || propertyName == "PolicyRequired")
                            return "Views['" + viewKey + "'].ControlGroups['" + groupKey + "'].Controls['" + controlKey + "'].Properties['" + propertyName + "'].Value";
                    }
                }
            }

        }

        return "\"\"";
    }

    attachDateProperty(control, propertyName) {

        if (control.FieldType == "DateTime" && propertyName == "setDate" && !propertyName.setDate) {
            Object.defineProperty(control, 'setDate', {
                set: function (value) {
                    var dateParts = [];
                    dateParts = value.split('/');
                    if (dateParts.length > 1) {
                        control.Value = value;
                        control.DateValue = { "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) };
                    } else {
                        control.Value = value;
                        dateParts = value.split('-');
                        control.DateValue = { "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) };
                    }
                }
            });
        }
        else if (control.FieldType == "DateTime" && propertyName == "setMinDate" && !propertyName.setMinDate) {
            Object.defineProperty(control, 'setMinDate', {
                set: function (value) {
                    var dateParts = [];
                    dateParts = value.split('-');
                    control.minDate = { "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) };
                }
            });
        }
        else if (control.FieldType == "DateTime" && propertyName == "setMaxDate" && !propertyName.setMaxDate) {
            Object.defineProperty(control, 'setMaxDate', {
                set: function (value) {
                    var dateParts = [];
                    dateParts = value.split('-');
                    control.maxDate = { "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) };
                }
            });
        }
    }

  //Functions related to Template
    requiredControls: Array<string> = [];

    //To validate required controls in a group within a step
    validateMandatoryGroupControls(wizard, stepKey, groupKey) {
        this.wizard = wizard;
        this.requiredControls = [];
        for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
            if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                !this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Value) {
                this.requiredControls.push(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
            }
        }
        return this.requiredControls;
    }

    //To validate all required controls in a step
    validateMandatoryStepControls(wizard, stepKey) {
        this.wizard = wizard;
        this.requiredControls = [];
        for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
            if (!this.wizard.Steps[stepKey].ControlGroups[groupKey].IsMultiline) {
                for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                    if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferVisible.Value == true &&
                        this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                        !this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Value) {
                        this.requiredControls.push(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                    }
                }
            }
            else {
                for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                    if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferVisible.Value == true &&
                        this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                        this.wizard.Steps[stepKey].ControlGroups[groupKey].LineCodes.length == 0) {
                        this.requiredControls.push(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                    }
                }
            }
        }
        return this.requiredControls;
    }

    //To validate all required controls in the wizard (before submit/update)
    validateMandatoryControls(wizard) {
        this.wizard = wizard;
        this.requiredControls = [];
        for (var stepKey in this.wizard.Steps) {
            for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                if (!this.wizard.Steps[stepKey].ControlGroups[groupKey].IsMultiline) {

                    for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferVisible.Value == true &&
                            this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                            !this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Value) {
                            this.requiredControls.push(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                        }
                    }
                }
                else {
                    for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferVisible.Value == true &&
                            this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                            this.wizard.Steps[stepKey].ControlGroups[groupKey].LineCodes.length == 0) {
                            this.requiredControls.push(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                        }
                    }
                }
            }
        }

        if (this.wizard.IsDocument == true) {
            for (var docKey in this.wizard.Documents) {
                if (this.wizard.Documents[docKey].IsMandatory &&
                    (this.wizard.Documents[docKey].Image == null || this.wizard.Documents[docKey].Image == "")) {
                    this.requiredControls.push(this.wizard.Documents[docKey].DocumentTypeText)
                }
            }
        }

        return this.requiredControls;
    }

    executeGlobalScript(referentials, wizardSteps, offerCode, variables, pageError, script, itemCode = null, sectionCode = null, parentItemCode = null) {
        if (!script) return;

        script = this.parseScript(wizardSteps, null, script, null, itemCode, sectionCode, parentItemCode);

        var tmpFunc = new Function('notificationService', 'Referential', 'Steps', 'OfferCode', 'Variables', 'IsError', 'Global', script);

        try {

            var global = { "Variables": variables }

            var result = tmpFunc(this.toastrService, referentials, wizardSteps, offerCode, variables, pageError, global, script);

            return result;

        } catch (err) {

            global = null;
            return err;
        }

    }


    
    referentialData(mode, referential, controlReferential, key, value, selectedValue) {
        referential["BonusClass"] = { "Code": "BonusClass", "Values": {} };
        referential["BonusClass"].Values["25"] = "08";
        this.selectedControl.BonusClass.Referential = "BonusClass";
        this.selectedControl.BonusClass.Value = "25";
    }


    getControlByName(wizardSteps, controlName) {
        for (var stepKey in wizardSteps) {
            for (var controlKey in wizardSteps[stepKey].Controls) {
                if (wizardSteps[stepKey].Controls[controlKey].Properties &&
                    wizardSteps[stepKey].Controls[controlKey].Properties['UserName'] &&
                    wizardSteps[stepKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                    return wizardSteps[stepKey].Controls[controlKey];
                }
            }

            for (var groupKey in wizardSteps[stepKey].ControlGroups) {
                for (var controlKey in wizardSteps[stepKey].ControlGroups[groupKey].Controls) {
                    if (wizardSteps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties &&
                        wizardSteps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'] &&
                        wizardSteps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                        return wizardSteps[stepKey].ControlGroups[groupKey].Controls[controlKey];
                    }
                }
            }

            for (var sectionKey in wizardSteps[stepKey].Sections) {
                for (var controlKey in wizardSteps[stepKey].Sections[sectionKey].Controls) {
                    if (wizardSteps[stepKey].Sections[sectionKey].Controls[controlKey].Properties &&
                        wizardSteps[stepKey].Sections[sectionKey].Controls[controlKey].Properties['UserName'] &&
                        wizardSteps[stepKey].Sections[sectionKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                        return wizardSteps[stepKey].Sections[sectionKey].Controls[controlKey];
                    }
                }
            }

            for (var sectionKey in wizardSteps[stepKey].Sections) {
                for (var groupKey in wizardSteps[stepKey].Sections[sectionKey].ControlGroups) {
                    for (var controlKey in wizardSteps[stepKey].Sections[sectionKey].ControlGroups[groupKey].Controls) {
                        if (wizardSteps[stepKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties &&
                            wizardSteps[stepKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'] &&
                            wizardSteps[stepKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                            return wizardSteps[stepKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey];
                        }
                    }
                }
            }

            if (wizardSteps[stepKey].Type == "Offer") {
                for (var offerKey in wizardSteps[stepKey].Offers) {

                    for (var controlKey in wizardSteps[stepKey].Offers[offerKey].Controls) {
                        if (wizardSteps[stepKey].Offers[offerKey].Controls[controlKey].Properties &&
                            wizardSteps[stepKey].Offers[offerKey].Controls[controlKey].Properties['UserName'] &&
                            wizardSteps[stepKey].Offers[offerKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                            return wizardSteps[stepKey].Offers[offerKey].Controls[controlKey];
                        }
                    }

                    for (var groupKey in wizardSteps[stepKey].Offers[offerKey].ControlGroups) {
                        for (var controlKey in wizardSteps[stepKey].Offers[offerKey].ControlGroups[groupKey].Controls) {
                            if (wizardSteps[stepKey].Offers[offerKey].ControlGroups[groupKey].Controls[controlKey].Properties &&
                                wizardSteps[stepKey].Offers[offerKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'] &&
                                wizardSteps[stepKey].Offers[offerKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                                return wizardSteps[stepKey].Offers[offerKey].ControlGroups[groupKey].Controls[controlKey];
                            }
                        }
                    }

                    for (var sectionKey in wizardSteps[stepKey].Offers[offerKey].Sections) {

                        for (var controlKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Controls) {
                            if (wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Controls[controlKey].Properties &&
                                wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Controls[controlKey].Properties['UserName'] &&
                                wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                                return wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Controls[controlKey];
                            }
                        }

                        for (var groupKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups) {
                            for (var controlKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups[groupKey].Controls) {
                                if (wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties &&
                                    wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'] &&
                                    wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                                    return wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].ControlGroups[groupKey].Controls[controlKey];
                                }
                            }
                        }

                        for (var coverKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers) {
                            for (var controlKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls) {
                                if (wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls[controlKey].Properties &&
                                    wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls[controlKey].Properties['UserName'] &&
                                    wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                                    return wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls[controlKey];
                                }
                            }

                            for (var groupKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups) {
                                for (var controlKey in wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups[groupKey].Controls) {
                                    if (wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups[groupKey].Controls[controlKey].Properties &&
                                        wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'] &&
                                        wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups[groupKey].Controls[controlKey].Properties['UserName'].Value == controlName) {
                                        return wizardSteps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].ControlGroups[groupKey].Controls[controlKey];
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }

        return null;
    }

    validateFormat(type, field) {

        if (field.Value && type == 1 &&
            field.Value.match(/^\d{5}-\d{2}$/) == null &&
            field.Value.match(/^\d{5}\d{2}$/) == null) {
            field.hasError = true; //NNNNN-NN
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 2 &&
            field.Value.match(/^\d{5}-\d{2}-\d{1}$/) == null &&
            field.Value.match(/^\d{5}\d{2}\d{1}$/) == null) {
            field.hasError = true; //NNNNN-NN-N
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 3 &&
            field.Value.match(/^\d{5}-[A-Z]{1}-\d{2}$/) == null &&
            field.Value.match(/^\d{5}[A-Z]{1}\d{2}$/) == null) {
            field.hasError = true; //NNNNN-A-NN
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 4 &&
            field.Value.match(/^\d{5}-[A-Z]{2}-\d{2}$/) == null &&
            field.Value.match(/^\d{5}[A-Z]{2}\d{2}$/) == null) {
            field.hasError = true; //NNNNN-AA-NN
            return false;
        }
        else if (field.Value && type == 5 &&
            field.Value.match(/^\d{5}-CD-\d{2}$/) == null &&
            field.Value.match(/^\d{5}CD\d{2}$/) == null) {
            field.hasError = true; //NNNNN-CD-NN
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 6 &&
            field.Value.match(/^[A-Z]{1}-\d{9}$/) == null &&
            field.Value.match(/^[A-Z]{1}\d{9}$/) == null) {
            field.hasError = true; //A-NNNNNNNNN
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 7 &&
            field.Value.match(/^WW-\d{7}$/) == null &&
            field.Value.match(/^WW\d{7}$/) == null) {
            field.hasError = true; //WW-NNNNNNN
            return false;
        }
        else if (field.Value && type == 8 &&
            field.Value.match(/^W18-\d{6}$/) == null &&
            field.Value.match(/^W18\d{6}$/) == null) {
            field.hasError = true; //W18-NNNNNN
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 9 &&
            field.Value.match(/^PAT-\d{5}-[A-Z]{2}-\d{2}$/) == null &&
            field.Value.match(/^PAT\d{5}[A-Z]{2}\d{2}$/) == null) {
            field.hasError = true; //PAT-NNNNN-AA-NN
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 13 &&
            field.Value.match(/^\d{4}-TU-\d{3}$/) == null &&
            field.Value.match(/^\d{4}TU\d{3}$/) == null) {
            field.hasError = true; //NNNN-TU-NNN
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 14 &&
            field.Value.match(/^\d{5}-[A-Z0-9]{3}-\d{2}$/) == null &&
            field.Value.match(/^\d{5}[A-Z0-9]{3}\d{2}$/) == null) {
            field.hasError = true; //NNNNN-XXX-NN
            return false;
        }
        else if (field.Value && type == 15 &&
            field.Value.match(/^\d{6}-[A-Z0-9]{3}$/) == null &&
            field.Value.match(/^\d{6}[A-Z0-9]{3}$/) == null) {
            field.hasError = true; //NNNNNN-XXX
            field.scriptError = true;
            return false;
        }
        else if (field.Value && type == 16 &&
            field.Value.match(/^\d{2}-\d{8}-[A-Z0-9]{2}$/) == null &&
            field.Value.match(/^\d{2}\d{8}[A-Z0-9]{2}$/) == null) {
            field.hasError = true; ///NN-NNNNNNNN-XX
            field.scriptError = true;
            return false;
        }
        else {
            field.hasError = false;
            field.scriptError = false;
            return true;
        }
    }

    
}
